import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsdCircle } from '@fortawesome/pro-solid-svg-icons';

import { Card } from '@buildoutinc/blueprint-react/ui/Card';
import { Checkbox } from '@buildoutinc/blueprint-react/ui/Checkbox';
import { Label } from '@buildoutinc/blueprint-react/ui/Label';
import { Tooltip } from '@buildoutinc/blueprint-react/ui/Tooltip';

import type { PermissionDescriptor } from 'components/users/types';

const BILLING_TOOLTIP =
  'Enabling this feature will affect billing. Please contact your Buildout Account Manager for additional information.';

interface Props {
  descriptor: PermissionDescriptor;
  checked: boolean;
  disabled: boolean;
  onChange: (attr: string, value: boolean) => void;
}

export default function PermissionCheckboxCard({ descriptor, checked, disabled, onChange }: Props) {
  const { attr, label, description, billingTooltip, svnNote } = descriptor;
  const inputId = `user_${attr}`;

  return (
    <div className="col-sm-6">
      <Card className="h-100">
        <Card.Body>
          <div className="d-flex align-items-start gap-2">
            <Checkbox
              checked={checked}
              className="mt-1 flex-shrink-0"
              disabled={disabled}
              id={inputId}
              onCheckedChange={value => onChange(attr, value === true)}
            />
            <Label className="clickable fw-normal" htmlFor={inputId}>
              <span className="d-block">
                {label}
                {billingTooltip && (
                  <Tooltip>
                    <Tooltip.Trigger
                      delay={0}
                      render={(
                        <span className="text-success ms-1">
                          <FontAwesomeIcon icon={faUsdCircle} />
                        </span>
                      )}
                    />
                    <Tooltip.Content>{BILLING_TOOLTIP}</Tooltip.Content>
                  </Tooltip>
                )}
              </span>
              <span className="d-block fw-light small mt-1">
                {description}
                {svnNote && ' If you want this permission changed email contracts@svn.com'}
              </span>
            </Label>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
